import axios from "axios";
import { LoggingConstants } from "Constants";
import { AxiosHelperSingleton, PendoHelperSingleton } from "Helpers";
import { TEnvironmentVariableDTO } from "Types";


export class EnvironmentController {
    public async createAsync(queryId: string, isFromDelivery: boolean, environment?: string, searchTermGroupId?: string): Promise<TEnvironmentVariableDTO> {
        const formData = new FormData();
        formData.append("isFromDelivery", isFromDelivery ? "true" : "false");
        formData.append("queryId", queryId);
        if (environment) formData.append("environment", environment);
        if (searchTermGroupId) formData.append("searchTermGroupId", searchTermGroupId);
        
        PendoHelperSingleton.trackEventWithProperties(`${LoggingConstants.DYNAMIC_DELIVERY}EnvironmentCreate`, {
            queryId: queryId
        });
        
        const result = await axios.post<TEnvironmentVariableDTO>(`${AxiosHelperSingleton.getServerBaseURL()}api/environments/Create`,
            formData, { headers: { "Content-Type": "multipart/form-data" } });
        return result.data;
    }

    public async updateAsync(environment: TEnvironmentVariableDTO, isFromDelivery: boolean,) {
        PendoHelperSingleton.trackEventWithProperties(`${LoggingConstants.DYNAMIC_DELIVERY}EnvironmentUpdate`, {
            environmentId: environment.id
        });
        
        const result = await axios.put(`${AxiosHelperSingleton.getServerBaseURL()}api/environments?isFromDelivery=${isFromDelivery ? "true" : "false"}`,
            environment);
        return result.status === 200;
    }

    public async deleteAsync(environmentId: number, isFromDelivery: boolean): Promise<boolean> {
        PendoHelperSingleton.trackEventWithProperties(`${LoggingConstants.DYNAMIC_DELIVERY}EnvironmentDelete`, {
            environmentId: environmentId
        });
        
        const result = await axios.delete(`${AxiosHelperSingleton.getServerBaseURL()}api/environments/${environmentId}?isFromDelivery=${isFromDelivery ? "true" : "false"}`);
        return result.status === 200;
    }
}

export const EnvironmentControllerSingleton = new EnvironmentController(); 